import { NativeAppEventEmitter, NativeModules, Platform } from 'react-native';
import { rtcAnswer, rtcQuery, rtcRequest } from '../net/service';
import { TopicWithSummary } from '../../imsdk/api/topic';
import * as ImSdk from '../../imsdk/api';
import { getUid } from '../store/token';
import { parseIds } from './helper';
import { User } from '../../imsdk/db/t_user';
import { GroupMember } from '../../imsdk/db/t_group_member';
import { RTCMsgNewData } from '../../imsdk/api/mq';
import { showToast } from '../components/Toast';
import { MessageType } from '../constants/types';
export class RTCEngine {
	static callListener() {
	}

	static async callRtcQueryStatus(rtcId: string): Promise<{ code: number; msg?: string; data?: any }> {
		return { code: -1,  };
	}
	// "rtc": {
	//   "rtcId": 10000000000, // 通话ID
	//   "type": "", // 消息类型 voice_rtc 或 video_rtc
	//   "appkey": "", // 应用标识
	//   "cid": "", // 客户端消息ID
	//   "tid": "", // 会话ID
	//   "mid": "", // 消息ID
	//   "sender": 10000000000, // 发送方
	//   "stime": 10000000000, // 发送时间 单位毫秒
	//   "memberCnt": 2, // 目标用户数
	//   "memberUids": [10000000000, 20000000000], // 目标用户id集
	//   "memberUids": [
	//     {
	//       "userId": 10000000000, // 用户ID
	//       "sdkToken": "", // 用户Token
	//       "status": "" // 状态 -1:canceled  0:pending  1:joined
	//     }
	//   ],
	//   "status": "" // 状态 -1:canceled  0:pending  1:ready  2:started  3:done
	// }

	static rtcQuery(rtcId: string) {
		return rtcQuery({ rtcId: rtcId });
	}
	//来电
	static async callDisplay(data: RTCMsgNewData) {
	}

	//主动发起
	static callRTC(topic: TopicWithSummary, isVideo: Boolean) {
	}

	private static call(rtcId: string, isVideo: Boolean, isSender: Boolean, user: User | GroupMember) {
	}
}
